import { OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.DELETED_ENTITY)
export default class DeletedEntity extends BaseModel {
  @StringField()
  public entityType: string

  @StringField()
  public entityId: string
}
